import { useMemo } from 'react'
import type { StripeElementLocale } from '@stripe/stripe-js'
import { useIntl } from 'react-intl'
import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { getEnabledLanguageLocales } from 'i18n/supportedLanguageOptions'
import { getStripeElementsLocale } from 'lib/payment/stripeUtils'

export function useStripeElementsLocale(): StripeElementLocale {
  const intl = useIntl()
  const languagesRemoteConfig = useLabRemoteConfig(
    LabRemoteConfigKeys.languages,
  )

  return useMemo(() => {
    return getStripeElementsLocale(
      intl.locale,
      getEnabledLanguageLocales(languagesRemoteConfig),
    )
  }, [intl.locale, languagesRemoteConfig])
}
